import {Formik} from 'formik';
import {I18n} from 'aws-amplify/utils';
import {
    Button,
    Group,
} from '@mantine/core';

import {
    useZonesFilter,
    ZonesFilters,
} from '../../hooks/useZonesQuery';
import {FilterFormComponent} from './FilterFormComponent';
import {ZonesFilterFormValues} from './filterOptions';

// Formik owns the DRAFT state; only Apply writes it to the module-scoped store.
// Typing in the drawer must not re-filter the table underneath it.
export const FilterForm = (
    {
        onApply,
        onCancel,
    }: {
        onApply: () => void,
        onCancel: () => void,
    },
) => {

    const {
        filters,
        handleSetFilters,
        handleClearFilters,
    } = useZonesFilter();

    // Seeded from the store so reopening the drawer shows what is applied,
    // rather than an empty form next to a filtered table.
    const initialValues: ZonesFilterFormValues = {
        provider: filters.provider ?? '',
        delegation: filters.delegation ?? '',
    };

    const onSubmit = (values: ZonesFilterFormValues) => {
        // Empty strings are DROPPED rather than stored. A stored empty value
        // would count toward the active-filter badge and read as a filter that
        // is on while matching everything.
        const clean = Object.entries(values)
                            .reduce((acc: ZonesFilters, [key, value]) => {
                                if (value) {
                                    acc[key] = value;
                                }
                                return acc;
                            }, {});
        handleSetFilters(clean);
        onApply();
    };

    return (
        <Formik<ZonesFilterFormValues>
            initialValues={initialValues}
            onSubmit={onSubmit}
            enableReinitialize={true}
        >
            {({
                  handleSubmit,
                  resetForm,
              }) => (
                <>
                    <FilterFormComponent/>
                    <Group justify={'space-between'} mt={'xl'}>
                        <Button variant={'outline'} onClick={onCancel}>
                            {I18n.get('Cancel')}
                        </Button>
                        <Group gap={'xs'}>
                            <Button
                                variant={'outline'}
                                onClick={() => {
                                    resetForm({
                                        values: {
                                            provider: '',
                                            delegation: '',
                                        },
                                    });
                                    handleClearFilters();
                                }}
                            >
                                {I18n.get('Clear')}
                            </Button>
                            <Button onClick={() => handleSubmit()}>
                                {I18n.get('Apply')}
                            </Button>
                        </Group>
                    </Group>
                </>
            )}
        </Formik>
    );
};
